import { render, staticRenderFns } from "./Subhead.vue?vue&type=template&id=17d5919a&scoped=true&"
import script from "./Subhead.vue?vue&type=script&lang=js&"
export * from "./Subhead.vue?vue&type=script&lang=js&"
import style0 from "./Subhead.vue?vue&type=style&index=0&id=17d5919a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d5919a",
  null
  
)

export default component.exports